<template>
  <div class="container">
    <ControlGroup>
      <DataGetter
        :url="`${url}/list/Country`"
        :params="{ CODE_INDICATOR: 'PRICEMONTHLY' }"
        v-slot="{ data }"
        :child-element-type="null"
      >
        <Dropdown
          v-if="data"
          label="Country"
          :options="data"
          v-model="country"
          reset-on-invalid
        />
      </DataGetter>
      <DataGetter
        :url="`${url}/list/CODE_PRODUCT`"
        :params="{ Country: country, CODE_INDICATOR: 'PRICEMONTHLY', CODE_SECTOR: 'TRANS' }"
        v-slot="{data}"
        @fetched="setProducts"
        :child-element-type="null"
      >
        <Dropdown
          v-if="data"
          label="Product"
          :options="data"
          v-model="product"
          reset-on-invalid
        />
      </DataGetter>
    </ControlGroup>
    <PriceTimeSeries
      :url="url"
      :baseCountry="country"
      sector="TRANS"
      :product="product"
      :topicName="productName"
      monthly
      :unit="unit"
    />
  </div>
</template>

<script>
import {
  DataGetter,
  ControlGroup,
  Dropdown
} from "@international-energy-agency/vue-ui";
import countryMixin from "./countryMixin";
import PriceTimeSeries from "./PriceTimeSeries.vue";
export default {
  props: {
    url: {
      type: String,
      default: "https://api.iea.org/prices",
      required: false,
    },
  },
  components: {
    DataGetter,
    ControlGroup,
    Dropdown,
    PriceTimeSeries,
  },
  mixins: [countryMixin],
  data() {
    return {
      sector: "TRANS",
      unit: "USDCUR",
      products: [],
      product: "GASOLINE",
      year: "2023",
    };
  },
  computed: {
    productName() {
      const { product } = this;
      return this.products.find((p) => p.value === product)?.label.toLowerCase() || '';
    }
  },
  methods: {
    setProducts(products) {
      this.products = products;
    }
  },
};
</script>